/* eslint-disable react/prop-types */
/* eslint-disable  react/no-array-index-key */
/* eslint-disable  jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdClose } from 'react-icons/md';
import './SsrSelectionStyles.scss';
import { formatCurrency } from '../../shared/helper-utils/appUtils';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import AppButton from '../../shared/components/app-button/AppButton';

export default function SeatSelectionComponent({
  showSeatMap,
  setShowSeatMap,
  flightLegsWithSeatsRef,
  userSelectedSsrRows,
  seatSelectionSector,
  setSeatSelectionSector,
  activeSeatIndex,
  setActiveSeatIndex,
  handleRemoveSeat,
  handleSeatSelection,
  isNormalBooking = true,
}) {
  const getDesignatorForSeat = (seat) => {
    const isEmpty = seat.additionalinfo?.indexOf('no-seat') > -1;
    const isUnavailable = seat.seatstatus.toLowerCase().indexOf('open') === -1;
    if (isEmpty) {
      return '';
    }
    if (isUnavailable) {
      return 'X';
    }
    return seat.seatdesignator;
  };
  const getSelectedSeat = (ssrRow, index, sector) => {
    let filteredSeatRows = [];
    if (Array.isArray(ssrRow)) {
      filteredSeatRows = ssrRow.filter(
        (x) => x.ssrcode !== '' && x.ssr_chargeableamount !== '',
      );
    }
    return (
      <div className="d-flex flex-column">
        {!isNormalBooking ? (
          <>
            <span>{ssrRow.fullName}</span>
          </>
        ) : (
          <>
            <span>
              {ssrRow.passenger_fname !== ''
                ? `${ssrRow.passenger_title} ${ssrRow.passenger_fname} ${ssrRow.passenger_lname}`
                : `Traveller ${index + 1}`}
            </span>
          </>
        )}
        {!isNormalBooking ? (
          <>
            {filteredSeatRows.length === 0 ? (
              <small className="traveller-name__subheading">Select Seat</small>
            ) : (
              <div className="d-flex gap-2 selected-seats align-items-center">
                <small className="traveller-name__subheading">
                  {`${filteredSeatRows[0].ssrcode} • ${formatCurrency(
                    filteredSeatRows[0].ssr_chargeableamount,
                  )}`}
                </small>{' '}
                {!filteredSeatRows[0].hasSsr && (
                  <AppIconButton
                    onClick={() =>
                      handleRemoveSeat(filteredSeatRows[0], sector)
                    }
                    variant="secondary"
                  >
                    <MdClose />
                  </AppIconButton>
                )}
              </div>
            )}
          </>
        ) : (
          <>
            {ssrRow.ssrcode === '' ? (
              <small className="traveller-name__subheading">Select Seat</small>
            ) : (
              <div className="d-flex gap-2 selected-seats align-items-center">
                <small className="traveller-name__subheading">
                  {`${ssrRow.ssrcode} • ${formatCurrency(
                    ssrRow.ssr_chargeableamount,
                  )}`}
                </small>{' '}
                <AppIconButton
                  onClick={() => handleRemoveSeat(ssrRow, sector)}
                  variant="secondary"
                >
                  <MdClose />
                </AppIconButton>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const getSeatToolTipText = (seat) => {
    const isEmpty = seat.additionalinfo?.indexOf('no-seat') > -1;
    const isUnavailable = seat.seatstatus.toLowerCase().indexOf('open') === -1;
    if (isEmpty) {
      return '';
    }
    if (isUnavailable) {
      return 'This seat is unavailable';
    }
    return (
      <>
        <span>{formatCurrency(seat.seatprice)}</span>
        <span>{seat.additionalinfo?.replace('margin-left', '')}</span>
      </>
    );
  };
  const getByName = (userBaggageRows) => {
    return userBaggageRows.reduce((acc, cur) => {
      if (acc[cur.fullName]) {
        acc[cur.fullName].push(cur);
      } else {
        acc[cur.fullName] = [cur];
      }
      return acc;
    }, {});
  };
  return (
    <Modal
      className="app-modal meal-modal"
      show={showSeatMap}
      onHide={() => setShowSeatMap(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Seats</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className="seat-selection-section">
          <div className="seat-sectors-row d-flex">
            {Object.keys(flightLegsWithSeatsRef).map((sector) => (
              <div
                key={sector}
                className={`seat-sector ${
                  seatSelectionSector === sector ? 'active-seat-sector' : ''
                }`}
                onClick={() => setSeatSelectionSector(sector)}
              >
                {sector}
              </div>
            ))}
          </div>
          <div className="separator" />
          {Object.keys(userSelectedSsrRows).length > 0 &&
            Object.keys(flightLegsWithSeatsRef).map((sector) => {
              const sectorSeats = flightLegsWithSeatsRef[sector]
                ? flightLegsWithSeatsRef[sector].seats
                : {};
              const seatLetters = flightLegsWithSeatsRef[sector]
                ? flightLegsWithSeatsRef[sector].seatLetterArray
                : [];
              const seatNumbers = flightLegsWithSeatsRef[sector]
                ? flightLegsWithSeatsRef[sector].seatDigitArray
                : [];
              const userSeatRows = userSelectedSsrRows[sector].seatRows;
              let byName;
              if (!isNormalBooking) {
                byName = getByName(userSeatRows);
              }
              return (
                userSelectedSsrRows[sector] &&
                seatSelectionSector === sector && (
                  <div key={sector} className="d-flex flex-sm-row flex-column">
                    <div className="d-flex flex-sm-column flex-row travellers-info overflow-auto">
                      {isNormalBooking ? (
                        <>
                          {userSelectedSsrRows[sector].seatRows &&
                            userSelectedSsrRows[sector].seatRows.map(
                              (ssrRow, index) =>
                                ssrRow.paxtype.toLowerCase() !== 'infant' && (
                                  <div
                                    className={`traveller-name ${
                                      activeSeatIndex === index &&
                                      'current-traveller-seat-selection'
                                    }`}
                                    key={index}
                                    onClick={() => setActiveSeatIndex(index)}
                                  >
                                    {getSelectedSeat(ssrRow, index, sector)}
                                  </div>
                                ),
                            )}
                        </>
                      ) : (
                        <>
                          {Object.keys(byName).map(
                            (fullName, index) =>
                              byName[fullName][0].paxtype.toLowerCase() !==
                                'infant' && (
                                <div
                                  className={`traveller-name ${
                                    activeSeatIndex === index &&
                                    'active-traveller'
                                  }`}
                                  key={index}
                                  onClick={() => setActiveSeatIndex(index)}
                                >
                                  {fullName}
                                  <small className="traveller-name__subheading">
                                    {getSelectedSeat(
                                      byName[fullName],
                                      fullName,
                                      sector,
                                    )}
                                  </small>
                                </div>
                              ),
                          )}
                        </>
                      )}
                    </div>
                    <div className="flight-seat-map d-flex justify-content-center align-items-center flex-1">
                      <div className="flight-seat-map_container">
                        <div className="flight-seat-map_cockpit">
                          <img src="/images/others/cockpit.svg" alt="" />
                        </div>
                        <div className="flight-seat-map_layout">
                          {Object.keys(sectorSeats).map(
                            (seatRow, seatRowIndex) => (
                              <div
                                key={seatRow}
                                className="d-flex position-relative"
                              >
                                <div
                                  className="flight-seat-map_row-designator_left-number"
                                  style={{
                                    marginTop: seatRowIndex === 0 ? '32px' : '',
                                  }}
                                >
                                  {seatNumbers[seatRowIndex]}
                                </div>
                                <div
                                  className="flight-seat-map_row-designator_right-number"
                                  style={{
                                    marginTop: seatRowIndex === 0 ? '32px' : '',
                                  }}
                                >
                                  {seatNumbers[seatRowIndex]}
                                </div>

                                {sectorSeats[seatRow].map((seat, index) => (
                                  <div
                                    key={index}
                                    className="d-flex flex-column align-items-center "
                                  >
                                    {seatRowIndex === 0 && (
                                      <div
                                        className={`flight-seat-map_row-designator ${
                                          seat.additionalinfo?.indexOf(
                                            'margin-left',
                                          ) > -1
                                            ? 'flight-seat-map_row-designator_aisle-space'
                                            : ''
                                        } `}
                                      >
                                        {seatLetters[index]}
                                      </div>
                                    )}
                                    <div
                                      className={`flight-seat-map_seat ${
                                        seat.additionalinfo?.indexOf(
                                          'margin-left',
                                        ) > -1
                                          ? 'flight-seat-map_aisle-space'
                                          : ''
                                      } ${
                                        seat.additionalinfo
                                          ?.toLowerCase()
                                          .indexOf('exitrow') > -1
                                          ? 'flight-seat-map_exit-row'
                                          : ''
                                      } ${
                                        seat.additionalinfo?.indexOf(
                                          'no-seat',
                                        ) > -1
                                          ? 'flight-seat-map_empty-space'
                                          : ''
                                      } ${
                                        seat.seatstatus
                                          .toLowerCase()
                                          .indexOf('open') === -1
                                          ? 'flight-seat-map_booked-seat'
                                          : ''
                                      } ${
                                        userSelectedSsrRows[
                                          sector
                                        ].seatRows.find(
                                          (s) =>
                                            s.ssrcode === seat.seatdesignator,
                                        )
                                          ? 'flight-seat-map_selected-seat'
                                          : ''
                                      } `}
                                    >
                                      {seat.additionalinfo?.indexOf('no-seat') >
                                      -1 ? (
                                        ''
                                      ) : (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip id="seat-info-tooltip">
                                              <div className="fs-10 d-flex flex-column">
                                                {getSeatToolTipText(seat)}
                                              </div>
                                            </Tooltip>
                                          }
                                        >
                                          <div
                                            className="seat-text"
                                            onClick={() =>
                                              handleSeatSelection(
                                                seat,
                                                sector,
                                                userSelectedSsrRows[
                                                  sector
                                                ].seatRows[0]?.carrier?.substring(
                                                  0,
                                                  2,
                                                ),
                                              )
                                            }
                                          >
                                            {getDesignatorForSeat(seat)}
                                          </div>
                                        </OverlayTrigger>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ),
                          )}
                        </div>
                        {/* <div className="flight-seat-map_cockpit">
                                <img src="/images/others/tailgate.svg" alt="" />
                              </div> */}
                      </div>
                    </div>
                  </div>
                )
              );
            })}
        </section>
      </Modal.Body>
      <Modal.Footer>
        <AppButton
          onClick={() => setShowSeatMap(false)}
          btnText="Continue"
          variant="outlined"
        />
      </Modal.Footer>
    </Modal>
  );
}
